import React from 'react';
import { Select, InputNumber } from '@clockout-dev/design-elements';
import { SendOutlined } from '@ant-design/icons';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import { STANDARD_DELIVERY_UNIT_OPTIONS } from '../../../configuration.constants';
import styles from '../styles/feeStructureForm.module.scss';

function StandardDeliveryCard({ time, unit, enabled, onChangeTime, onChangeUnit, onToggleEnabled }) {
    return (
        <ConfigurationCard
            title="Standard Transfer Delivery"
            icon={<SendOutlined />}
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <div className={styles.fieldGroup}>
                <InputNumber
                    value={time}
                    onChange={onChangeTime}
                    min={1}
                    max={999}
                    controls={false}
                    className={styles.deliveryTimeInput}
                />
                <Select
                    id="standardDeliveryUnit"
                    size="large"
                    value={unit}
                    options={STANDARD_DELIVERY_UNIT_OPTIONS}
                    onChange={onChangeUnit}
                    className={`${styles.select} ${styles.selectMd}`}
                />
            </div>
        </ConfigurationCard>
    );
}

export default StandardDeliveryCard;
